export const pathConstants = {
  mobile: '/mobile',
  trip: '/mobile/trip',
  tripDetails: '/mobile/trip/details',
  table: '/mobile/table',
  ship: '/mobile/ship',
  shipData: '/mobile/ship/shipdata',
  performance: '/mobile/performance',
  performanceIndicators: '/mobile/performance/performanceIndicators',
  account: '/mobile/account',
  more: '/mobile/more',
  about: '/mobile/about',
  disclaimer: '/mobile/disclaimer',
  logout: '/logout',
  language: '/mobile/language',
  appUpdates: '/mobile/app-updates',
};

export const desktopRoutes = {
  desktop: '/desktop',
  performance: '/desktop/performance',
  ships: '/desktop/ships',
  fleet: '/desktop/fleet',
  account: '/desktop/account',
  about: '/desktop/more/about',
  disclaimer: '/desktop/more/disclaimer',
  language: '/desktop/more/language',
  appUpdates: '/desktop/app-updates',
};
